import IMask from 'imask';

const FormMaskedInputHook = {
  mounted() {
    this.cmd = this.js();

    this.maskedInput = this.el.querySelector('[type=text]');
    this.hiddenInput = this.el.querySelector('[type=hidden]');

    this.mask = new IMask(this.maskedInput, this.options());

    this.maskedInput.value = this.mask.value;
    this.maskedInput.setAttribute('value', this.mask.value);

    this.maskedInput.addEventListener('input', (e) => {
      e.stopPropagation();

      this.maskedInput.value = this.mask.value;
      // this.maskedInput.setAttribute('value', this.mask.value);

      this.hiddenInput.value = this.mask.unmaskedValue;
      // this.hiddenInput.setAttribute('value', this.mask.value);

      // We need it because of custom events on hidden inputs like phx-change
      const changeEvent = new Event('input', { bubbles: true, cancelable: true });
      this.hiddenInput.dispatchEvent(changeEvent);
    });
  },

  updated() {
    this.mask.unmaskedValue = this.hiddenInput.value;

    this.maskedInput.value = this.mask.value;
    this.maskedInput.setAttribute('value', this.mask.value);

    this.mask.updateValue();
  },

  beforeDestroy() {
    this.mask.destroy();
  },

  options() {
    switch (this.el.dataset.mask) {
      case 'tel':
        return { mask: '(000) 000-0000' };
      case 'number':
        return {
          min: parseInt(this.el.dataset.min),
          max: this.el.dataset.max && parseInt(this.el.dataset.max),
          mask: Number,
          scale: parseInt(this.el.dataset.scale),
          thousandsSeparator: ',',
          padFractionalZeros: false,
          normalizeZeros: true,
          radix: '.',
        };
      default:
        return { mask: this.el.dataset.mask };
    }
  },
};

export default FormMaskedInputHook;
